import { createAction } from 'redux-actions'
import Cookies from 'universal-cookie'

import isBrowser from 'utils/isBrowser'
import { getRootDomain } from 'utils/domainName'

export const TOGGLE_PRIVACY_NOTICES = 'Privacy notice: Toggle GDPR info on ad reply'

export const togglePrivacyNotices = createAction(TOGGLE_PRIVACY_NOTICES)

const toggle = (payload) => (dispatch) => {
  dispatch(togglePrivacyNotices(payload))

  if (isBrowser()) {
    const cookies = new Cookies()
    cookies.set('privacyNotice', payload, {
      path: '/',
      secure: false,
      httpOnly: false,
      maxAge: 60 * 60 * 24 * 365 * 100, // 100 years
      domain: `.${getRootDomain(document.location.href)}`,
    })
  }
}

export const actionCreators = {
  toggle,
}
